import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// Layout
import Topo from './Components/Layout/Topo';

import Login from './Components/Users/Login';
import RecuperarSenha from './Components/Users/RecuperarSenha';
import Suspenso from './Components/Users/Suspenso';

class App extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      permission: false,
      deferredPrompt: null,
    }
    this.promptInstall = this.promptInstall.bind(this);

  }

    componentDidMount() {

      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.setState({deferredPrompt: e});
      });
    

      var url_login = config.get('url') + '/usuario/login';
      var url_suspended = config.get('url') + '/usuario/suspenso';
      var url_recovery_pw = config.get('url') + '/usuario/recuperar_senha';
      var url_flight_report_index = 'relatorios/voo';
      var url_flight_report_edit = 'relatorio/voo/editar';
      var url_staff_deslocation_edit = 'tripulante/deslocamento/editar';
      var url_actual = window.location.href;

      if(!navigator.onLine && !url_actual.includes(url_flight_report_index) && !url_actual.includes(url_flight_report_edit)) {
        window.location.replace(config.get('url') + '/relatorios/voo');
      }

      if(url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw && !url_actual.includes(url_staff_deslocation_edit)) {
        // busco as infos
        var params = JSON.parse(localStorage.getItem("cid"));
        // Verifico se há algum storage setado
        if(params === null || typeof params === 'undefined') {
          window.location.replace(config.get('url') + '/usuario/login');
        } else {
          // Verifico se o cid acode setado
          if(params.acode === null || typeof params.acode === 'undefined') {
            window.location.replace(config.get('url') + '/usuario/login');
          } else {
            this.setState({permission: true});
          }
        }
      } else {
        this.setState({permission: true});
      }
    }

    async promptInstall() {
      if(this.state.deferredPrompt === null) {
        window.open(config.get('cdn') + '/tutorials/instrucoes-instalacao.pdf');
      } else {
        // Show the install prompt
        this.state.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await this.state.deferredPrompt.userChoice;
        // We've used the prompt, and can't use it again, throw it away
        this.setState({deferredPrompt: null});
      }
    };

  render() {
    return (
      <div>
        {
          (this.state.permission === false) ? '' :
            <div>
              <BrowserRouter>
                <Switch>

                  {/* Usuarios */}
                  <Route promptInstall={this.promptInstall} path="/usuario/login" render={(props) => <Login {...props} promptInstall={this.promptInstall} />} />
                  <Route promptInstall={this.promptInstall} path="/usuario/recuperar_senha" render={(props) => <RecuperarSenha {...props} promptInstall={this.promptInstall} />} />
                  <Route promptInstall={this.promptInstall} path="/usuario/suspenso" render={(props) => <Suspenso {...props} promptInstall={this.promptInstall} />} />
                  <Route promptInstall={this.promptInstall} path="/" render={(props) => <Topo {...props} promptInstall={this.promptInstall} />} />
                </Switch>
              </BrowserRouter>
            </div>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js